import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, msalInitialized, login } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('PrivateRoute isAuthenticated:', isAuthenticated);

    // Only attempt to login if MSAL is initialized
    if (msalInitialized && isAuthenticated === false) {
      console.log('PrivateRoute Logging in')
      login();
    }

    // Set loading to false once both MSAL initialization and authentication state are resolved
    if (msalInitialized && isAuthenticated !== null) {
      setIsLoading(false);
    }
  }, [isAuthenticated, msalInitialized]);

  console.log('isAuthenticated:', isAuthenticated, 'isLoading:', isLoading);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : children;
};

export default PrivateRoute;
